import React from 'react';
import { Link } from 'react-router-dom';
import RoutePath from '../../../constants/route-paths';
import Theming from '../../../constants/theming';
import { getSmallUrl } from '../../../helpers/image_helpers';
import MediaHelpers from '../../../helpers/media_file_helpers';
import { genRoutePath } from '../../../helpers/route_helpers';
import { NewsletterModel } from '../../../models/newsletter';
import PlaceholderImg from '../../templates/PlaceholderImg';

const routeToNewsletter = (newsletterId: string) => genRoutePath([RoutePath.newsletters, newsletterId]);

interface NewsletterCardProps {
    newsletter: NewsletterModel;
}

export default class NewsletterCard extends React.Component<NewsletterCardProps> {
    render() {
        return (
            <div className="col-lg-4 col-md-6 mb-4">

                <div className="card">

                    <div className="view overlay">
                        <PlaceholderImg
                            blurhash={this.props.newsletter.thumbnail.formats.blurhash}
                            style={{ height: "30vh", objectFit: "cover" }} className="card-img-top"
                            src={MediaHelpers.resolveMediaUrl(getSmallUrl(this.props.newsletter.thumbnail))} alt={this.props.newsletter.thumbnail.alternativeText} />
                        <Link to={routeToNewsletter(this.props.newsletter.id)}>
                            <div className="mask rgba-white-slight"></div>
                        </Link>
                    </div>

                    <div className="card-body text-left">
                        <p>
                            <strong>
                                <i className="far fa-clock"></i> {new Date(this.props.newsletter.date).toLocaleDateString("en-IN")}
                            </strong>
                        </p>

                        <h4 className="card-title">{this.props.newsletter.title}</h4>

                        <Link to={routeToNewsletter(this.props.newsletter.id)} className="btn btn-md" style={{ backgroundColor: Theming.backgroundColourDark, color: Theming.textColourDark }}>
                            More Details
            <i className="fas fa-play ml-2"></i>
                        </Link>
                    </div>

                </div>
            </div>
        );
    }
}